"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectNumberDTO = void 0;
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
class ProjectNumberDTO {
}
exports.ProjectNumberDTO = ProjectNumberDTO;
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.Length)(5, 5),
    __metadata("design:type", String)
], ProjectNumberDTO.prototype, "clientNumber", void 0);
__decorate([
    (0, class_validator_1.IsNumber)({ maxDecimalPlaces: 0 }),
    (0, class_transformer_1.Type)(() => Number),
    (0, class_validator_1.Min)(0),
    (0, class_validator_1.Max)(99),
    __metadata("design:type", Number)
], ProjectNumberDTO.prototype, "year", void 0);
__decorate([
    (0, class_validator_1.IsNumber)({ maxDecimalPlaces: 0 }),
    (0, class_transformer_1.Type)(() => Number),
    (0, class_validator_1.Min)(1),
    __metadata("design:type", Number)
], ProjectNumberDTO.prototype, "sequentialNumber", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Type)(() => Boolean),
    __metadata("design:type", Boolean)
], ProjectNumberDTO.prototype, "firstAcquisition", void 0);
